import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { RoleEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface CreateRoleInput { orgId: string; name: string; description?: string | null; }
export function createCreateRoleUseCase({ membershipRepository }: Deps) {
  return async function createRole(input: CreateRoleInput): Promise<RoleEntity> {
    return membershipRepository.createRole(input);
  };
}
